module.exports = __webpack_public_path__ + "1c006807d9e64349eb1a6e7dd97ad35c.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/sp-editable-image/sp-editable-image.html
// module id = 1083
// module chunks = 0